import {
  SET_POINTS,
  RESET_POINTS_MAP,
  REMOVE_POINTS
} from '../constants/actionTypes';

const trajectoryPoints = (state = {points:[]}, action) => {
  switch (action.type) {
    case SET_POINTS:
      return {
        ...state,
        points: action.payload.points.points? [...state.points, action.payload.points.points]: state.points,
        start: action.payload.points.start === undefined ? state.start : action.payload.points.start,
        end: action.payload.points.end === undefined ? state.end :  action.payload.points.end,
        captcha: action.payload.points.captcha === undefined ? state.captcha :  action.payload.points.captcha
      };
    case RESET_POINTS_MAP:
      return {
          ...state,
          points: [],
          start: null,
          end: null,
          captcha: null
        };
    case REMOVE_POINTS:
      return {
        ...state,
        points: action.payload.id? state.points.filter(p => p.Id !== action.payload.id): state.points
        };              
    default:
      return state;
  }
};

export default trajectoryPoints;